import axiosInstance from '../../../lib/axios'
import { API_ENDPOINTS } from '../../../constants/api'
import type { TranscriptSummary } from '../../../types/transcript.types'

interface GetDailySummaryArgs {
  propertyId: number
  day?: string
  refresh?: boolean
}

export const transcriptSummaryService = {
  async getDailySummary({ propertyId, day, refresh }: GetDailySummaryArgs): Promise<TranscriptSummary | null> {
    const params = new URLSearchParams()
    params.set('property_id', String(propertyId))
    if (day) params.set('day', day)
    if (refresh) params.set('refresh', 'true')

    try {
      const { data } = await axiosInstance.get<TranscriptSummary>(
        API_ENDPOINTS.CONVERSATIONS_SUMMARY(params.toString()),
      )
      return data
    } catch {
      return null
    }
  },
}
